<template>
  <div class="kt-grid kt-grid--hor kt-grid--root">
    <KTHeaderMobile></KTHeaderMobile>
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <div
      class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"
    >
      <KTAside v-if="asideEnabled"></KTAside>
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper"
        id="kt_wrapper"
      >
        <KTHeader></KTHeader>
        <div
          class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
          id="kt_content"
        >
          <!-- <KTSubheader
            v-if="subheaderDisplay"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          ></KTSubheader> -->
          <KTSubheader
            v-if="subheaderDisplay"
            v-bind:title="pageTitle"
          ></KTSubheader>
          <div
            class="kt-container kt-grid__item kt-grid__item--fluid"
            v-bind:class="{ 'kt-container--fluid': contentFluid }"
          >
            <v-app>
              <transition name="fade-in-up">
                <router-view></router-view>
              </transition>
            </v-app>
          </div>
        </div>
        <KTFooter></KTFooter>
        <b-modal ref="inactivity-modal" :title="$t('AUTO_CLOSE.TITLE')">
          <p class="my-1">{{ $t("AUTO_CLOSE.DESC") }}</p>
          <P>{{ $t("AUTO_CLOSE.TIME_REMAIN", { sec: timeleft }) }}</P>
          <template v-slot:modal-footer>
            <b-button variant="outline-secondary" v-on:click="onLogout()">
              {{ $t("COMMON.CANCEL") }}
            </b-button>
            <b-button variant="primary" v-on:click="modalClose()">
              {{ $t("COMMON.OK") }}
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
    <!-- <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar> -->
    <!-- <KTQuickPanel></KTQuickPanel> -->
    <KTScrollTop></KTScrollTop>
  </div>
</template>
<style lang="scss" scoped>
.theme--light.v-application {
  background: inherit;
}
</style>
<script>
import { mapGetters } from "vuex";
import KTAside from "@/views/theme/aside/Aside.vue";
import KTHeader from "@/views/theme/header/Header.vue";
import KTHeaderMobile from "@/views/theme/header/HeaderMobile.vue";
import KTFooter from "@/views/theme/footer/Footer.vue";
import HtmlClass from "@/common/htmlclass.service";
import KTSubheader from "@/views/theme/subheader/Subheader.vue";
// import KTStickyToolbar from "@/views/partials/layout/StickyToolbar.vue";
// import KTQuickPanel from "@/views/partials/layout/QuickPanel.vue";
import KTScrollTop from "@/views/partials/layout/ScrollTop";
import Loader from "@/views/partials/content/Loader.vue";
import { LOGOUT } from "@/store/auth.module";
import { postRequest } from "@/api/request.js";
import SessionTimeoutService from "@/common/session-timeout.service";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/store/htmlclass.module.js";

export default {
  name: "Base",
  components: {
    KTAside,
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    // KTStickyToolbar,
    // KTQuickPanel,
    KTScrollTop,
    Loader,
  },
  data: () => ({
    timeleft: Math.ceil(SessionTimeoutService.getWarningOffsetMs() / 1000),
  }),
  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, "kt-page--loading");

    // initialize html element classes
    HtmlClass.init();
  },
  mounted() {
    // check if current user is authenticated
    // if (!this.isAuthenticated) {
    //   this.$router.push({ name: "login" });
    // }

    // Simulate the delay page loading
    setTimeout(() => {
      // Remove page loader after some time
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "kt-page--loading");
    }, 2000);

    window.addEventListener(
      SessionTimeoutService.SESSION_UPDATED_EVENT,
      this.handleSessionTimeoutUpdated
    );
    window.addEventListener("storage", this.handleStorageUpdated);
    this.scheduleSessionTimers();
  },
  beforeDestroy() {
    this.clearSessionTimers();
    window.removeEventListener(
      SessionTimeoutService.SESSION_UPDATED_EVENT,
      this.handleSessionTimeoutUpdated
    );
    window.removeEventListener("storage", this.handleStorageUpdated);
  },
  methods: {
    clearSessionTimers() {
      clearTimeout(this.warningTimer);
      clearTimeout(this.logoutTimer);
      clearInterval(this.countdownTimer);
    },
    handleSessionTimeoutUpdated() {
      this.scheduleSessionTimers();
    },
    handleStorageUpdated(event) {
      if (event.key === "session_expires_at") {
        this.scheduleSessionTimers();
      }
    },
    scheduleSessionTimers() {
      this.clearSessionTimers();
      const expiresAt = SessionTimeoutService.getExpiresAt();
      if (!expiresAt || !localStorage.id_token) return;

      const now = Date.now();
      const warningAt = expiresAt - SessionTimeoutService.getWarningOffsetMs();
      const msUntilWarning = warningAt - now;
      const msUntilLogout = expiresAt - now;

      if (msUntilLogout <= 0) {
        this.onLogout();
        return;
      }

      this.logoutTimer = setTimeout(this.onLogout, msUntilLogout);
      if (msUntilWarning <= 0) {
        this.showAutoModal();
      } else {
        if (this.$refs["inactivity-modal"]) {
          this.$refs["inactivity-modal"].hide();
        }
        this.warningTimer = setTimeout(this.showAutoModal, msUntilWarning);
      }
    },
    showAutoModal() {
      if (!this.$refs["inactivity-modal"]) return;
      this.updateCountdownTime();
      this.$refs["inactivity-modal"].show();
      clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(this.updateCountdownTime, 1000);
    },
    onLogout() {
      this.clearSessionTimers();
      this.$store
        .dispatch(LOGOUT, { token: localStorage.id_token, action: "logout" })
        .then(() => this.$router.push({ name: "login" }));
    },
    modalClose() {
      postRequest({
        action: "getAdminInfo",
        token: localStorage.id_token,
      }).then((res) => {
        if (res && res.returncode) {
          this.$refs["inactivity-modal"].hide();
        } else {
          this.onLogout();
        }
      });
    },
    updateCountdownTime() {
      const expiresAt = SessionTimeoutService.getExpiresAt();
      this.timeleft = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
      if (this.timeleft <= 0) {
        this.onLogout();
      }
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      // "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),

    /**
     * Check if the page laoder is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !!this.layoutConfig("loader.enabled");
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      return !!this.layoutConfig("toolbar.display");
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>
